.tabs {
  display: flex;
  flex-direction: column;
  gap: var(--space-m);
}

.strip {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2xs);

  border-block-end: 1px solid var(--border);
}

.tab {
  padding: var(--space-2xs) var(--space-s);

  font: inherit;
  font-size: var(--size-200);

  color: var(--text-muted);
  background-color: transparent;

  border: none;
  /* The active tab is marked by a rule that meets the strip's own line. */
  border-block-end: 2px solid transparent;

  cursor: pointer;
}

.tab:hover {
  color: var(--accent);
}

.active {
  color: var(--text);

  border-block-end-color: var(--accent);
}

.panel:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: var(--space-3xs);
}
